import React from "react";
import { connect } from "react-redux";
import * as builder from "../../ducks/builder";
import Brand from "../brand/Brand";
import Menu from "./Menu";
import KTOffcanvas from "../../_assets/js/offcanvas";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

class AsideLeft extends React.Component {
	asideOffCanvasRef = React.createRef();

	componentDidMount() {
		// eslint-disable-next-line
		this.ktOffCanvas = new KTOffcanvas(
			this.asideOffCanvasRef.current,
			this.props.menuCanvasOptions
		);
	}

	componentWillUnmount() {
		if (this.ktOffCanvas) {
			this.ktOffCanvas.hide();
		}
	}

	render() {
		return (
			<>
				<button className="kt-aside-close" id="kt_aside_close_btn">
					<i className="la la-close" />
				</button>

				<div
					id="kt_aside"
					ref={this.asideOffCanvasRef}
					className={`kt-aside`}
				>
					<Brand />

					<div
						id="kt_aside_menu_wrapper"
						className="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid"
					>
						<Menu htmlClassService={this.props.htmlClassService} />
					</div>

					<Link className="logout" to={'/logout'}>
						<Icon icon="solar:logout-2-linear" width="24" />
						<span>Sair</span>
					</Link>
				</div>
			</>
		);
	}
}

const mapStateToProps = store => ({
	disableAsideSelfDisplay:
		builder.selectors.getConfig(store, "aside.self.display") === false,
	disableScroll:
		builder.selectors.getConfig(store, "aside.menu.dropdown") === "true" ||
		false,
	asideClassesFromConfig: builder.selectors.getClasses(store, {
		path: "aside",
		toString: true
	}),
	menuCanvasOptions: {
		baseClass: "kt-aside",
		overlay: true,
		closeBy: "kt_aside_close_btn",
		toggleBy: {
			target: "kt_aside_mobile_toggler",
			state: "kt-header-mobile__toolbar-toggler--active"
		}
	}
});

export default connect(mapStateToProps)(AsideLeft);
